export const MESSAGE_ALIGN = {
  LEFT: 'left',
  RIGHT: 'right',
} as const;

export const TEXT_FORMAT = {
  MARKDOWN: 'TEXT_FORMAT_MARKDOWN',
  PLAIN_TEXT: 'TEXT_FORMAT_PLAIN',
  LEGACY: 'TEXT_FORMAT_LEGACY',
} as const;
